<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- Per Page -->
          <list-per-page
            :total="total"
            :current-per-page="perPage"
            @onChangePerPage="changePerPage"
          />
          <b-button
            v-if="$can('create','resellers')"
            variant="success"
            @click="createButtonClicked"
          >
            {{ $t('Create reseller') }}
            <feather-icon icon="PlusIcon" />
          </b-button>
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <list-search @onSearch="search" />
          </div>
        </b-col>
      </b-row>
    </div>
    <table-loader v-if="loader" />
    <resellers-list
      v-else
      :fields="fields"
      :items="items"
      :additional-data="additionalData"
    />

    <list-pagination
      :current="page"
      :current-per-page="perPage"
      :from="from"
      :to="to"
      :total="total"
      :total-page="totalPage"
      @onChangePage="changePage"
    />
  </b-card>
</template>

<script>
import { ListIndex } from '../../../common/mixins/list'
import ResellersList from '../../../components/admin/resellers/list/ResellersList'

export default {
  components: {
    ResellersList,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'resellers',
      adminFields: [
        {
          key: 'user',
          label: this.$t('User'),
        },
        {
          key: 'fixed_amount',
          label: this.$t('Fixed amount'),
        },
        {
          key: 'percent',
          label: this.$t('Percent'),
        },
        {
          key: 'source',
          label: this.$t('Source'),
        },
        {
          key: 'action',
          label: '',
        },
      ],
    }
  },
}
</script>

<style lang="scss">

</style>
